export default "__VITE_ASSET__93o9_ZWc__"